import { TertiaryButton } from '../../../../components/execution/TertiaryButton'
import RenderHTML from '../../../../components/ui-components/RenderHTML'
import { lightImpactVibrate } from '../../../../utils/appBridge'

const planRecommendationFundTileCompletedCheckIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M2.5 7.25L5.75 10.5L11.5 4.25" stroke="#2A9C4A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

export function PlanRecommendationFundTileActionFooter({
  actionLabel,
  isCompleted,
  onActionClick
}: {
  actionLabel: string
  isCompleted: boolean
  onActionClick?: () => void
}) {
  if (isCompleted) {
    return (
      <div className="flex h-[40px] w-full items-center justify-center gap-1 rounded-[8px] bg-[#EFF9F0] text-[13px] font-[500] leading-[130%] text-[#2A9C4A]">
        <RenderHTML innerHTMLText={planRecommendationFundTileCompletedCheckIconSvg} />
        <span>Completed</span>
      </div>
    )
  }

  return (
    <TertiaryButton
      onClick={(clickEvent) => {
        clickEvent.stopPropagation()
        lightImpactVibrate()
        onActionClick?.()
      }}
      tertiaryButtonClassName="!h-[40px] !py-3 !leading-[130%] !font-[500] !text-[14px] !rounded-[8px] !border-none"
      label={actionLabel}
    />
  )
}
